__turbopack_context__.v({
  "button": "home-module-scss-module__RvYFJW__button",
  "description": "home-module-scss-module__RvYFJW__description",
  "homeWrp": "home-module-scss-module__RvYFJW__homeWrp",
  "intro": "home-module-scss-module__RvYFJW__intro",
  "introAnimationContainer": "home-module-scss-module__RvYFJW__introAnimationContainer",
  "introAnimationShadow": "home-module-scss-module__RvYFJW__introAnimationShadow",
  "introContent": "home-module-scss-module__RvYFJW__introContent",
  "introPattern": "home-module-scss-module__RvYFJW__introPattern",
  "paperPlane": "home-module-scss-module__RvYFJW__paperPlane",
  "paperPlane1": "home-module-scss-module__RvYFJW__paperPlane1",
  "paperPlane2": "home-module-scss-module__RvYFJW__paperPlane2",
  "paperPlane3": "home-module-scss-module__RvYFJW__paperPlane3",
  "title": "home-module-scss-module__RvYFJW__title",
});
